// Mirror of apps/api/src/billing/features.ts. Manually kept in sync until
// sub-spec 12 extracts a shared package. If you change one, change both —
// the catalogue is the contract between server gate and client UI.

export type AccountTier = 'starter' | 'pro' | 'enterprise';

export const FEATURE_FLAGS = {
  multi_facility: ['pro', 'enterprise'],
  custom_portal_domain: ['pro', 'enterprise'],
  sms_reminders: ['pro', 'enterprise'],
  whatsapp_comms: ['pro', 'enterprise'],
  pos: ['pro', 'enterprise'],
  live_stay_page: ['pro', 'enterprise'],
  ip_camera_embed: ['pro', 'enterprise'],
  embed_widget: ['pro', 'enterprise'],
  daycare_packs: ['pro', 'enterprise'],
  marketing_tools: ['pro', 'enterprise'],
  calendar_integrations: ['pro', 'enterprise'],
  microchip_lookup: ['pro', 'enterprise'],
  gbp_review_requests: ['pro', 'enterprise'],
  customisation_surfaces: ['pro', 'enterprise'],
  advanced_reports: ['pro', 'enterprise'],
  capacitor_staff_app: ['pro', 'enterprise'],
  customer_pwa: ['starter', 'pro', 'enterprise'],
  quickbooks_xero: ['enterprise'],
  public_api: ['enterprise'],
  outbound_webhooks: ['enterprise'],
  sso: ['enterprise'],
  audit_retention_extended: ['enterprise'],
  multiple_kiosks: ['pro', 'enterprise'],
} as const satisfies Record<string, ReadonlyArray<AccountTier>>;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

/**
 * Client-side feature check. Loose-typed `tier` accepts string | null |
 * undefined so callers can pass `me?.activeAccount?.tier` without nullish
 * coalescing. Falls closed on null/undefined/unknown values — same posture
 * as the server's hasFeature.
 */
export function hasFeatureOnClient(
  tier: AccountTier | string | null | undefined,
  flag: FeatureFlag,
): boolean {
  if (!tier) return false;
  const tiers = FEATURE_FLAGS[flag] as ReadonlyArray<string>;
  return tiers.includes(tier);
}
